<template lang="pug">
div
  div.header
    div.title
      h2.title_item {{ $t('strings.project_summary') }}
      img.icon(src="@/assets/crane_2.svg")
    div.button_container
      button.btn_download_pdf(v-if="project.purchase_order != null" @click="downloadPurchaseOrder(project.file_public_url)")
        img.icon(src="@/assets/pdf.svg" style="padding-top: 0.6rem;")
        span.download_text &nbsp; {{ $t('projects_dashboard.download_pdf') }}
  div.project_statistics
    div.main_statistic(style="padding-bottom: 2rem;")
      div.side_color(style="background-color: #e0e0e0")
      div(style="padding-left: 3rem;")
        img(src="@/assets/crane.png")
        strong.project_name {{ project.name}}
        span.project_customer {{ project.customer.name }}
        span.location {{ project.location }},
        span.location &nbsp;{{  project.country}}
        span.project_date {{ project.created_at | moment("DD MMMM YYYY") }}
        span.initial_amount(style="margin-top: 0.5rem;") 💵 {{ $t('projects_dashboard.initial_amount') }}:
        span.initial_amount {{ project.price | currency }}
    div.secondary_statistic
      div.statistic_row
        div.statistic
          div.side_color(style="background-color: #a5170f")
          span.statistic_text {{ $t('projects_dashboard.sale_amount')}}
          strong.statistic_number {{ project.sale_amount | currency}}
          span#iva_include *Incluye IVA
        div.statistic
          div.side_color(style="background-color: #049856")
          span.statistic_text  {{ $t('projects_dashboard.additives_total')}}
          strong.statistic_number {{ project.additives | currency }}
        div.statistic
          div.side_color(style="background-color: #bb8700")
          span.statistic_text {{ $t('projects_dashboard.income')}}
          strong.statistic_number {{ income | currency }}
      div.statistic_row
        div.statistic
          div.side_color(style="background-color: #ff5d54")
          span.statistic_text {{ $t('projects_dashboard.utility')}}
          strong.statistic_number {{ project.utility | currency }}
        div.statistic
          div.side_color(style="background-color: #6dfea8")
          span.statistic_text {{ $t('projects_dashboard.deductibles_total')}}
          strong.statistic_number {{ project.deductibles | currency }}
        div.statistic
          div.side_color(style="background-color: #fedf89")
          span.statistic_text {{ $t('projects_dashboard.expenses')}}
          strong.statistic_number {{ expenses | currency }}
  br
  h2 {{ $t('projects_dashboard.change_orders')}}
  br
  ChangeOrders(@delete="refreshStatistics" :projectId="project.id")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')
export default {
  components: {
    ChangeOrders: () => import('@/components/dashboard/projects/ChangeOrders.vue')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPage: 1,
    date: '',
    currentId: null
  }),
  computed: {
    ...mapGetters([
      'project'
    ]),
    income () {
      return this.project.concepts.filter(this.filterByStatus).reduce((previousValue, currentValue) => {
        return previousValue + +currentValue.payment
      }, 0)
    },
    expenses () {
      return this.project.concepts.filter(this.filterByStatus).reduce((previousValue, currentValue) => {
        return previousValue + +currentValue.charge
      }, 0)
    }
  },
  async created () {
    await this.loadRecord({ id: this.$route.params.id })
  },
  methods: {
    ...mapActions([
      'loadRecord',
      'exportPurchaseOrder',
      'exportChangeOrder'
    ]),
    async refreshStatistics () {
      await this.loadRecord({ id: this.$route.params.id })
    },
    filterByStatus (concept) {
      return concept.status === 1
    },
    downloadPurchaseOrder (url) {
      this.exportPurchaseOrder(url)
    }
  }
}
</script>
<style scoped lang="scss">
@import './project_dashboard_structure.css';
#iva_include {
  font-size: 0.9vw;
  display: flex;
  padding-left: 3rem;
  color: gray;
}
</style>
